import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IProcessRequest } from "../../../model/request/IProcessRequest";
import { IDanhSachTroCapDuyetRequest } from "../../../model/request/tro-cap/IDanhSachTroCapDuyetRequest";
import { IDanhSachTroCapSelectByLopsRequest } from "../../../model/request/tro-cap/IDanhSachTroCapSelectByLopsRequest";
import { IDanhSachTroCapViewModel } from "../../../model/respone/tro-cap/IAccDanhSachTroCapHocPhi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDanhSachTroCapActionsObj = {
  LOAD_START: {} as IDanhSachTroCapSelectByLopsRequest,
  LOAD_SUCCESS: {} as IDanhSachTroCapViewModel[],
  LOAD_ERRR: "",

  CHANGE_FOCUS_TREEVIEW_VALUE: {} as ITreeviewLopFocusedValue | undefined,
  CHANGE_DISPLAY_MODE: {} as "full" | "popup",

  CHANGE_DOI_TUONG: 0,
  CHANGE_TROCAP_SELECTED_IDS: [] as string[],
  CHANGE_TYPE_DISPLAY: 0,

  DUYET_START: {} as IProcessRequest<IDanhSachTroCapDuyetRequest>,
  DUYET_SUCCESS: [] as IDanhSachTroCapViewModel[],
  DUYET_ERROR: "",

  HUY_DUYET_START: {} as IProcessRequest<IDanhSachTroCapDuyetRequest>,
  HUY_DUYET_SUCCESS: [] as IDanhSachTroCapViewModel[],
  HUY_DUYET_ERROR: "",

  CLOSE_PROCESSING_MODAL: undefined,
};
export const eDanhSachTroCapActionIds = generateActionTypeIds(
  eDanhSachTroCapActionsObj,
  "DANH_SACH_TRO_CAP"
);
export type IDanhSachTroCapActionTypes = IGenericActionType<
  typeof eDanhSachTroCapActionsObj,
  "DANH_SACH_TRO_CAP"
>;
